










import { Vue, Component } from 'vue-property-decorator';
import AltasCrm from '@/pantallas/Conecta/AltasCrm/index.vue';

@Component({
  components: { AltasCrm },
})
export default class AltasCrmPantalla extends Vue {}
